<template>
  <div class="app-session">
    <VSvgIcon data-testid="app-session-logo" :icon="channel.logo || ''" tag="24"/>
    <span class="app-session__text">
     {{message.text}}
    </span>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import VSvgIcon from "@/modules/common/components/VSvgIcon";

export default {
  name: 'AppSession',
  components: {
    VSvgIcon,
  },
  props: {
    message: {
      type: Object,
      required: true,
      validator: (message) => {
        return !!message.text &&
               message.channels && message.channels.length > 0
      }
    },
  },
  computed: {
    ...mapGetters('accountModule', ['channels']),
    channel() {
      return this.channels.find(channel => channel.value === this.message.channels[0]) || {}
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/abstract/_variables';

.app-session {
  border-radius: 6px;
  padding: 12px 16px;
  background-color: $grey-color-21;
  display: flex;
  align-items: center;

  &__text {
    padding-inline-start: 12px;
    font-size: 13px;
    font-weight: 600;
  }
}
</style>
